module.exports = __webpack_public_path__ + "static/media/spray-can.82cd11dd.svg";